var React = require('react');

function CardSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M306 47.0039V17.8745C302.87 17.8745 300.333 15.6794 300.333 12.9717C300.333 10.2639 302.87 8.06885 306 8.06885V0H0V8.06885C3.12964 8.06885 5.66675 10.2639 5.66675 12.9717C5.66675 15.6794 3.12964 17.8745 0 17.8745V47.0039C0 55.286 7.6394 62 17.0632 62H288.937C298.361 62 306 55.286 306 47.0039Z","fill":"white"}));
}

CardSmall.defaultProps = {"viewBox":"0 0 306 62","fill":"none"};

module.exports = CardSmall;

CardSmall.default = CardSmall;
